import React from 'react';
import {
  Route, Routes,
} from 'react-router-dom';

import CustomerPermissionsProvider from '@contexts/customer_permissions_context';
import CustomerList from '@pages/customer/list';
import CustomerNew from '@pages/customer/new';

export default function CustomersRoutes() {
  return (
    <CustomerPermissionsProvider>
      <Routes>
        <Route path='/admin/customers' element={<CustomerList />} />
        <Route path='/admin/customers/new' element={<CustomerNew />} />
      </Routes>
    </CustomerPermissionsProvider>
  );
}
